/** Default quotation terms per vertical. Owners edit these during setup. */
export const TERM_SETS: Readonly<Record<string, readonly string[]>> = {
  'car-detailing': [
    'Quote valid for 30 days from the date of issue.',
    'A 30% deposit confirms the booking; balance is due on completion.',
    'Vehicle must be free of personal belongings before work begins.',
    'Pre-existing paint or trim damage is documented before work starts.',
    'Ceramic and glass coatings carry a written warranty on request.',
  ],
  'pressure-washing': [
    'Quote valid for 30 days and based on the measured area stated above.',
    'Client to provide access to an outdoor water supply and power point.',
    'Delicate surfaces are soft-washed at lower pressure at our discretion.',
    'Severe staining may require an additional treatment, quoted separately.',
  ],
  plumbing: [
    'Quote valid for 30 days and covers labour and listed materials only.',
    'Hidden damage found once work begins will be re-quoted before proceeding.',
    'All workmanship is guaranteed for 12 months from completion.',
    'Emergency call-outs outside business hours are charged at the stated rate.',
  ],
  electrician: [
    'Quote valid for 30 days and assumes existing circuits are to current code.',
    'All work is carried out by a licensed electrician and certified on completion.',
    'Any rewiring required to meet code will be re-quoted before proceeding.',
    'Materials remain the property of the contractor until paid in full.',
  ],
  hvac: [
    'Quote valid for 30 days and is priced per indoor/outdoor unit.',
    'Refrigerant top-up beyond the quoted charge is billed at cost.',
    'Installation assumes a suitable mounting surface and power supply within 3 m.',
    'Servicing carries a 90-day workmanship guarantee.',
  ],
  'lawn-care': [
    'Quote valid for 30 days and based on the measured area stated above.',
    'Green waste removal is included unless noted otherwise.',
    'Recurring maintenance is billed per visit at the agreed rate.',
    'Access to the property and a water point is required on the day.',
  ],
  'home-cleaning': [
    'Quote valid for 30 days and assumes normal soil levels.',
    'Cleaning products and equipment are supplied by us.',
    'Please secure pets and valuables before the team arrives.',
    'Rescheduling within 24 hours of the booking may incur a fee.',
  ],
  'salon-spa': [
    'Quote valid for 30 days and reserved against the stated appointment.',
    'Please arrive 10 minutes before your appointment time.',
    'Cancellations within 12 hours may be charged at 50%.',
    'Patch tests are required 48 hours before any colour service.',
  ],
  other: [
    'Quote valid for 30 days from the date of issue.',
    'A deposit may be required to confirm the booking.',
    'Prices exclude any items not explicitly listed above.',
  ],
};

export const FALLBACK_TERMS: readonly string[] = TERM_SETS.other ?? [];

export function getTerms(templateId: string): readonly string[] {
  return TERM_SETS[templateId] ?? FALLBACK_TERMS;
}
